import _defineProperty from "C:\\Users\\wgharbi\\Desktop\\wejdi Github\\my portfolio\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import _slicedToArray from "C:\\Users\\wgharbi\\Desktop\\wejdi Github\\my portfolio\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useState, useRef, createElement, useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import { initialConfig } from "./config";
import "./TypingStep.css";
/**
 * @function TypingStep
 * An UI Component to render fully customisable Typing Effect
 *
 * @param {string || array} sequence
 *  An array of commands to be executed
 *      @param {string || number} content
 *          The command to be executed.
 *          * String denotes add command
 *          * Positive number denotes delay command
 *          * Negative number denotes number of characters to delete
 *      @param {object} config
 *          Set of local configurations that overrides global config
 *             @param {number} typeSpeed
 *             @param {string} styleClass
 *             @param {number} letterSpacing
 *             @param {number} cursorThickness
 *             @param {string} cursorColor
 *             @param {number} cursorPadding
 *             @param {number} deleteSpeed
 *             @param {number} blinkingSpeed
 * @param {number} typeSpeed
 *  Typing speed in milliseconds
 * @param {boolean} ignoreInitialDelay
 *  Whether to start with empty render or first letter already rendered
 * @param {string || React Element} element
 *  HTML Element or an user defined React Component
 * @param {string} styleClass
 *  Optional style class to be passed along with the text
 * @param {number} letterSpacing
 *  Space between each letter
 * @param {number} cursorThickness
 *  Thickness of the cursor
 * @param {string} cursorColor
 *  Color of the cursor
 * @param {number} cursorPadding
 *  Distance between last word and cursors
 * @param {number} deleteSpeed
 *  Delete speed in milliseconds
 * @param {number} blinkingSpeed
 *  Blinking speed of cursor in milliseconds
 * @param {boolean || number} disableBlinkingOnEnd
 *  Disable blinking on end or wait for a few blinks
 */
// Commands that can be executed

var ACTIONS = {
  ADD: "ADD",
  DELETE: "DELETE",
  DELAY: "DELAY"
};

var TypingStep = function TypingStep(props) {
  var sequence = props.sequence,
      typeSpeed = props.typeSpeed,
      ignoreInitialDelay = props.ignoreInitialDelay,
      htmlElement = props.element,
      styleClass = props.styleClass,
      letterSpacing = props.letterSpacing,
      cursorThickness = props.cursorThickness,
      cursorColor = props.cursorColor,
      cursorPadding = props.cursorPadding,
      deleteSpeed = props.deleteSpeed,
      blinkingSpeed = props.blinkingSpeed,
      disableBlinkingOnEnd = props.disableBlinkingOnEnd; // Cannot pass empty array

  if (sequence.length === 0) {
    throw new Error("Sequence cannot be an empty array");
  } // First argument must be a string


  if (typeof sequence[0].content !== "string") {
    throw new Error("First command must be string");
  } // Initial State for sequence configuration


  var initialState = {
    index: 0,
    information: sequence[0],
    length: ignoreInitialDelay ? 1 : 0
  };
  var initialText = ignoreInitialDelay ? sequence[0].content.charAt(0) : ""; // Current text that is to be rendered

  var _useState = useState(initialText),
      _useState2 = _slicedToArray(_useState, 2),
      currentText = _useState2[0],
      setCurrentText = _useState2[1]; // Current sequence that is being executed


  var _useState3 = useState(initialState),
      _useState4 = _slicedToArray(_useState3, 2),
      currentContent = _useState4[0],
      setCurrentContent = _useState4[1]; // Whether execution has been completed


  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isComplete = _useState6[0],
      setIsComplete = _useState6[1];

  var timer = useRef(null); // Unmounts the timer on component unmount

  var unmountTimer = function unmountTimer() {
    var timeoutInfo = timer.current;

    if (timeoutInfo) {
      // Checks if timer has been already been stopped
      timer.current = undefined;
      clearTimeout(timeoutInfo);
    }
  };
  /******************* Current Command *******************/


  var getCurrentCommand = function getCurrentCommand(content) {
    if (typeof content === "string") {
      return ACTIONS.ADD; // String means add command
    } else {
      if (content > 0) {
        return ACTIONS.DELAY; // Positive number means delay
      } else {
        return ACTIONS.DELETE; // Negative number means delete
      }
    }
  };

  var content = currentContent.information.content;
  var CURRENT_COMMAND = getCurrentCommand(content);
  /******************* Current Speed *******************/
  // Local value takes precedence over global values

  var currentTimeOutSpeed = undefined;

  switch (CURRENT_COMMAND) {
    case ACTIONS.ADD:
      {
        currentTimeOutSpeed = typeSpeed; // Global value

        if (currentContent.information.hasOwnProperty("config")) {
          var config = currentContent.information.config;

          if (config.hasOwnProperty("typeSpeed")) {
            // Check if local value is passed
            var currentSequenceTypeSpeed = config.typeSpeed;
            currentTimeOutSpeed = currentSequenceTypeSpeed;
          }
        }

        break;
      }

    case ACTIONS.DELAY:
      {
        var information = currentContent.information;
        currentTimeOutSpeed = information.content;
        break;
      }

    case ACTIONS.DELETE:
      {
        currentTimeOutSpeed = deleteSpeed;

        if (currentContent.information.hasOwnProperty("config")) {
          var _config = currentContent.information.config;

          if (_config.hasOwnProperty("deleteSpeed")) {
            // local value takes precedence
            var currentSequenceDeleteSpeed = _config.deleteSpeed;
            currentTimeOutSpeed = currentSequenceDeleteSpeed;
          }
        }

        break;
      }

    default:
      {
        currentTimeOutSpeed = 0; // Should not occur
      }
  } // Utility function to change the command


  var switchCommand = useCallback(function () {
    var currentIndex = currentContent.index;

    if (currentIndex === sequence.length - 1) {
      // End of commands
      unmountTimer();
      setIsComplete(true);
    } else {
      // Goto next command
      setCurrentContent({
        index: currentIndex + 1,
        information: sequence[currentIndex + 1],
        length: 0 // No need to ignore firstCommandDelay here

      });
    }
  }, [currentContent, sequence]); // Function to add text from the current command or switch to the next command

  var addText = useCallback(function () {
    var currentCommand = currentContent.information,
        currentLength = currentContent.length;

    if (currentLength === currentCommand.content.length) {
      // If the current command has finished
      switchCommand();
    } else {
      setCurrentContent(_objectSpread({}, currentContent, {
        length: currentLength + 1
      }));
      var currentString = currentText.concat(currentCommand.content.charAt(currentLength) // Concat the current letter
      );
      setCurrentText(currentString); // Update the current string
    }
  }, [currentContent, currentText, switchCommand]); // Function to delay execution of the next command

  var delay = useCallback(function () {
    switchCommand(); // The delay is already over by the time this function is called
  }, [switchCommand]); // Function to delete text based on the current command

  var deleteText = useCallback(function () {
    var currentCommand = currentContent.information,
        currentLength = currentContent.length;

    if (currentLength === Math.abs(currentCommand.content)) {
      switchCommand();
    } else if (currentText.length === 0) {
      // Trying to delete on an empty string

      /* eslint no-console: ["error", { allow: ["warn"] }] */
      console.warn("Trying to delete on an empty string");
      switchCommand();
    } else {
      setCurrentContent(_objectSpread({}, currentContent, {
        length: currentLength + 1
      }));
      var currentString = currentText.slice(0, currentText.length - 1); // Remove the last character

      setCurrentText(currentString);
    }
  }, [currentContent, currentText, switchCommand]); // Decides how to execute the current command

  var executeCommand = useCallback(function () {
    switch (CURRENT_COMMAND) {
      case ACTIONS.ADD:
        {
          addText();
          break;
        }

      case ACTIONS.DELAY:
        {
          delay();
          break;
        }

      case ACTIONS.DELETE:
        {
          deleteText();
          break;
        }

      default:
        {
          /* eslint no-console: ["error", { allow: ["warn"] }] */
          console.warn("Command not defined"); // Erroneous condition that shouldn't occur
        }
    }
  }, [addText, deleteText, delay, CURRENT_COMMAND]); // Execute the command based on the timeout speed

  useEffect(function () {
    timer.current = setTimeout(executeCommand, currentTimeOutSpeed);
    return unmountTimer;
  }, [currentTimeOutSpeed, executeCommand]);
  var stringToRender = currentText;
  /******************* LOCAL CONFIGURATION *******************/

  var typeSpeedCurrent = typeSpeed;
  var blinkingSpeedCurrent = blinkingSpeed;
  var letterSpacingCurrent = letterSpacing;
  var cursorThicknessCurrent = cursorThickness;
  var cursorColorCurrent = cursorColor;
  var cursorPaddingCurrent = cursorPadding;
  var styleClassCurrent = styleClass; // Override global configuration if provided

  if (currentContent.information.hasOwnProperty("config")) {
    var _config2 = currentContent.information.config;

    if (_config2.hasOwnProperty("typeSpeed")) {
      typeSpeedCurrent = _config2.typeSpeed;
    }

    if (_config2.hasOwnProperty("blinkingSpeed")) {
      blinkingSpeedCurrent = _config2.blinkingSpeed;
    }

    if (_config2.hasOwnProperty("letterSpacing")) {
      letterSpacingCurrent = _config2.letterSpacing;
    }

    if (_config2.hasOwnProperty("cursorThickness")) {
      cursorThicknessCurrent = _config2.cursorThickness;
    }

    if (_config2.hasOwnProperty("cursorColor")) {
      cursorColorCurrent = _config2.cursorColor;
    }

    if (_config2.hasOwnProperty("cursorPadding")) {
      cursorPaddingCurrent = _config2.cursorPadding;
    }

    if (_config2.hasOwnProperty("styleClass")) {
      styleClassCurrent = _config2.styleClass;
    }
  }
  /******************* STYLE CONFIGURATION *******************/


  var animationStyleConfig = "";

  if (isComplete) {
    // Set to global properties on completion
    typeSpeedCurrent = typeSpeed;
    blinkingSpeedCurrent = blinkingSpeed;
    letterSpacingCurrent = letterSpacing;
    cursorThicknessCurrent = cursorThickness;
    cursorColorCurrent = cursorColor;
    cursorPaddingCurrent = cursorPadding;
    styleClassCurrent = styleClass;

    if (typeof disableBlinkingOnEnd === "boolean") {
      // Check if a boolean value is passed
      if (disableBlinkingOnEnd) {
        // Disable blinking right away
        animationStyleConfig = "typing ".concat(typeSpeedCurrent / 1000, "s steps(20, end), stop-blink ").concat(blinkingSpeedCurrent / 1000, "s steps(1) infinite");
      } else {
        // Do not disable blinking
        animationStyleConfig = "typing ".concat(typeSpeedCurrent / 1000, "s steps(20, end), blink ").concat(blinkingSpeedCurrent / 1000, "s steps(1) infinite");
      }
    } else {
      // Blink for some time and then stop
      animationStyleConfig = "blink ".concat(blinkingSpeedCurrent / 1000, "s steps(1) infinite, stop-blink ").concat(blinkingSpeedCurrent / 1000, "s ").concat(disableBlinkingOnEnd * blinkingSpeedCurrent / 1000, "s steps(1) infinite\n      ");
    }
  } else {
    // Animation is ongoing. Continue blinking
    animationStyleConfig = "typing ".concat(typeSpeedCurrent / 1000, "s steps(20, end), blink ").concat(blinkingSpeedCurrent / 1000, "s steps(1) infinite");
  }

  var letterSpacingStyleConfig = "".concat(letterSpacingCurrent, "em");
  var borderRightStyleConfig = "".concat(cursorThicknessCurrent, "em solid ").concat(cursorColorCurrent);
  var paddingRightStyleConfig = "".concat(cursorPaddingCurrent, "em"); // Create a React element based on the html element or React Component supplied by the user

  var typeWriterText = function typeWriterText() {
    return stringToRender.split("\n").filter(function (ele) {
      return ele.length !== 0;
    }).map(function (ele, index, array) {
      var returnBorderProperty = function returnBorderProperty() {
        if (index + 1 === array.length) {
          return borderRightStyleConfig;
        } else {
          return "transparent";
        }
      };

      var reactElement =
      /*#__PURE__*/
      createElement(htmlElement, {
        className: "".concat(styleClassCurrent),
        key: "".concat(index)
      },
      /*#__PURE__*/
      React.createElement("span", {
        id: "typing-effect__sid200026__text__step" // Should always be unique
        ,
        style: {
          animation: animationStyleConfig,
          letterSpacing: letterSpacingStyleConfig,
          borderRight: returnBorderProperty(),
          paddingRight: paddingRightStyleConfig
        }
      }, ele));
      return reactElement;
    });
  };

  return (
    /*#__PURE__*/
    React.createElement("div", {
      className: ".typing-effect__typewriter__typing_step"
    }, typeWriterText())
  );
};
/******************* PROP VALIDATION *******************/


TypingStep.propTypes = {
  sequence: PropTypes.arrayOf(PropTypes.shape({
    content: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    config: PropTypes.shape({
      typeSpeed: PropTypes.number,
      styleClass: PropTypes.string,
      letterSpacing: PropTypes.number,
      cursorThickness: PropTypes.number,
      cursorColor: PropTypes.string,
      cursorPadding: PropTypes.number,
      deleteSpeed: PropTypes.number,
      blinkingSpeed: PropTypes.number
    })
  })).isRequired,
  ignoreInitialDelay: PropTypes.bool,
  disableBlinkingOnEnd: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
  typeSpeed: PropTypes.number,
  element: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  styleClass: PropTypes.string,
  letterSpacing: PropTypes.number,
  cursorThickness: PropTypes.number,
  cursorColor: PropTypes.string,
  cursorPadding: PropTypes.number,
  deleteSpeed: PropTypes.number,
  blinkingSpeed: PropTypes.number
};
TypingStep.defaultProps = {
  typeSpeed: initialConfig.typeSpeed,
  ignoreInitialDelay: initialConfig.ignoreInitialDelay,
  element: initialConfig.element,
  styleClass: initialConfig.styleClass,
  letterSpacing: initialConfig.letterSpacing,
  cursorThickness: initialConfig.cursorThickness,
  cursorColor: initialConfig.cursorColor,
  cursorPadding: initialConfig.cursorPadding,
  deleteSpeed: initialConfig.deleteSpeed,
  blinkingSpeed: initialConfig.blinkingSpeed,
  disableBlinkingOnEnd: initialConfig.disableBlinkingOnEnd
};
export { TypingStep };